module.exports = __webpack_public_path__ + "static/img/028_TO8_1488.d1c6cb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/028_TO8_1488.jpg
// module id = 0TVx
// module chunks = 0